import { c as _c } from "react/compiler-runtime";
import { Divider, Stack, Typography } from '@mui/material';
import { HelpIcon } from './helpIcon';
import { CopyToClipboardButton } from '../buttons/copyToClipboardButton';
export function CopyableCode(t0) {
  const $ = _c(48);
  const {
    title,
    code,
    codeClassName,
    variant,
    tooltipTitle,
    maxHeight,
    blur: t1
  } = t0;
  const blur = t1 === undefined ? false : t1;
  const color = variant === "error" ? "var(--mui-palette-error-main)" : "var(--mui-palette-text-primary)";
  const bgColorClass = variant === "error" ? "bg-(--mui-palette-error-opacity)" : "bg-(--mui-palette-background-secondary)";
  if (title) {
    const t2 = `w-full p-[16px] ${bgColorClass} rounded-[4px]`;
    let t3;
    if ($[0] !== color) {
      t3 = <Divider sx={{
        borderStyle: "dashed",
        borderColor: color
      }} />;
      $[0] = color;
      $[1] = t3;
    } else {
      t3 = $[1];
    }
    let t4;
    if ($[2] !== maxHeight) {
      t4 = {
        gap: "12px",
        maxHeight
      };
      $[2] = maxHeight;
      $[3] = t4;
    } else {
      t4 = $[3];
    }
    let t5;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = {
        gap: "8px",
        alignItems: "center",
        justifyContent: "space-between"
      };
      $[4] = t5;
    } else {
      t5 = $[4];
    }
    let t6;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
      t6 = {
        fontWeight: "bold"
      };
      $[5] = t6;
    } else {
      t6 = $[5];
    }
    let t7;
    if ($[6] !== color || $[7] !== title) {
      t7 = <Typography variant="subtitle1" color={color} sx={t6}>{title}</Typography>;
      $[6] = color;
      $[7] = title;
      $[8] = t7;
    } else {
      t7 = $[8];
    }
    let t8;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
      t8 = {
        gap: "8px",
        alignItems: "center"
      };
      $[9] = t8;
    } else {
      t8 = $[9];
    }
    let t9;
    if ($[10] !== tooltipTitle) {
      t9 = tooltipTitle && <HelpIcon alwaysVisible={true} title={tooltipTitle} className="text-xl" tooltipProps={{
        disableInteractive: false
      }} />;
      $[10] = tooltipTitle;
      $[11] = t9;
    } else {
      t9 = $[11];
    }
    const t10 = blur ? "" : code;
    const t11 = blur ? "Fill all required fields before copy" : undefined;
    const t12 = `text-[${color}]`;
    let t13;
    if ($[12] !== t10 || $[13] !== t11 || $[14] !== t12) {
      t13 = <CopyToClipboardButton textToCopy={t10} disabledTooltip={t11} className={t12} />;
      $[12] = t10;
      $[13] = t11;
      $[14] = t12;
      $[15] = t13;
    } else {
      t13 = $[15];
    }
    let t14;
    if ($[16] !== t13 || $[17] !== t9) {
      t14 = <Stack direction="row" sx={t8}>{t9}{t13}</Stack>;
      $[16] = t13;
      $[17] = t9;
      $[18] = t14;
    } else {
      t14 = $[18];
    }
    let t15;
    if ($[19] !== t14 || $[20] !== t7) {
      t15 = <Stack direction="row" sx={t5}>{t7}{t14}</Stack>;
      $[19] = t14;
      $[20] = t7;
      $[21] = t15;
    } else {
      t15 = $[21];
    }
    let t16;
    if ($[22] !== blur || $[23] !== code || $[24] !== codeClassName || $[25] !== color) {
      t16 = <CodeBlock code={code} className={codeClassName} color={color} blur={blur} />;
      $[22] = blur;
      $[23] = code;
      $[24] = codeClassName;
      $[25] = color;
      $[26] = t16;
    } else {
      t16 = $[26];
    }
    let t17;
    if ($[27] !== t15 || $[28] !== t16 || $[29] !== t2 || $[30] !== t3 || $[31] !== t4) {
      t17 = <Stack className={t2} divider={t3} sx={t4}>{t15}{t16}</Stack>;
      $[27] = t15;
      $[28] = t16;
      $[29] = t2;
      $[30] = t3;
      $[31] = t4;
      $[32] = t17;
    } else {
      t17 = $[32];
    }
    return t17;
  }
  const t2 = `w-full p-[16px] ${bgColorClass} rounded-[4px]`;
  let t3;
  if ($[33] !== maxHeight) {
    t3 = {
      gap: "8px",
      alignItems: "start",
      maxHeight
    };
    $[33] = maxHeight;
    $[34] = t3;
  } else {
    t3 = $[34];
  }
  let t4;
  if ($[35] !== blur || $[36] !== code || $[37] !== codeClassName || $[38] !== color) {
    t4 = <CodeBlock code={code} className={codeClassName} color={color} blur={blur} />;
    $[35] = blur;
    $[36] = code;
    $[37] = codeClassName;
    $[38] = color;
    $[39] = t4;
  } else {
    t4 = $[39];
  }
  const t5 = blur ? "" : code;
  const t6 = `text-[${color}]`;
  let t7;
  if ($[40] !== t5 || $[41] !== t6) {
    t7 = <CopyToClipboardButton textToCopy={t5} className={t6} />;
    $[40] = t5;
    $[41] = t6;
    $[42] = t7;
  } else {
    t7 = $[42];
  }
  let t8;
  if ($[43] !== t2 || $[44] !== t3 || $[45] !== t4 || $[46] !== t7) {
    t8 = <Stack direction="row" className={t2} sx={t3}>{t4}{t7}</Stack>;
    $[43] = t2;
    $[44] = t3;
    $[45] = t4;
    $[46] = t7;
    $[47] = t8;
  } else {
    t8 = $[47];
  }
  return t8;
}
const CodeBlock = t0 => {
  const $ = _c(6);
  const {
    code,
    className,
    color,
    blur: t1
  } = t0;
  const blur = t1 === undefined ? false : t1;
  const t2 = ` break-pretty w-full whitespace-pre overflow-x-auto text-[13px] text-[${color}] ${className ?? ""}`;
  let t3;
  if ($[0] !== blur || $[1] !== code) {
    t3 = blur ? <span className="select-none pointer-events-none" style={{
      userSelect: "none",
      color: "var(--mui-palette-text-disabled)"
    }}>{code}</span> : code;
    $[0] = blur;
    $[1] = code;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== t2 || $[4] !== t3) {
    t4 = <code className={t2}>{t3}</code>;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
};